import styled from 'styled-components';

const MessageMLStyled = styled.div`
  display: flex;
  flex-direction: column;
  .message-title {
    flex: 1;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 42px;
    span {
      cursor: pointer;
    }
    .message-title-checkbox {
      color: #000000;
    }
    .message-title-info {
      font-size: 16px;
      font-weight: 400;
      color: #212121;
      line-height: 22px;
      &.message-title-info-detail {
        color: rgba(0, 0, 0, 0.38);
      }
    }
  }
  .single-select {
    width: 100%;
    height: auto;
    margin-top: 19px;
    div {
      color: #000000;
    }
  }
  .message-content-wrap {
    border: 1px solid #979797;
    padding: 12px 16px 15px 16px;
    width: 260px;
    height: 195px;
    margin-top: 12px;
    &.no-padding {
      padding: 0;
      border: none;
    }
    .message-content-no {
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .message-content {
      width: 228px;
      height: 132px;
      overflow: auto;
      font-size: 14px;
      background: #f9f9f9;
      padding: ${(props) => props.theme.spacing(2)};
      color: #222222;
      &.message-content-detail {
        color: #000;
        opacity: 0.5;
      }
      .preview-box-content-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
        text-align: center;
        margin-bottom: 12px;
        color: #171717;
      }
      .preview-box-content-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        color: #171717;
        margin-bottom: 4px;
      }
      .preview-box-content-text-custom {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-weight: 400;
        font-size: 12px;
        line-height: 100%;
        color: #999999;
        margin-bottom: 16px;
        margin-top: 8px;
      }
      .preview-box-content-button {
        width: 211px;
        height: 36px;
        gap: 12px;
        padding: 8px 12px 8px 12px;
        border-radius: 8px;
        background-color: #898989;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 500;
        margin-bottom: 16px;
      }
      .preview-box-content-reason {
        border-radius: 12px;
        background-color: #f5f6f9;
        padding: 16px;
        .preview-box-content-reason-title {
          font-weight: 600;
          font-size: 12px;
          line-height: 100%;
          margin-bottom: 4px;
          text-align: center;
          color: #555555;
        }
        .preview-box-content-reason-text {
          font-weight: 400;
          font-size: 12px;
          color: #555555;
        }
      }
    }
  }
`;
export default MessageMLStyled;
